module.exports = __webpack_public_path__ + "img/3f_r_seven.c4f929a1.jpg";